var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"name",attrs:{"value":_vm.value,"rules":_vm.rules.applicationName,"label":"Name","hint":"The application name","counter":"255"},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }